'use strict';

/* global $ */

import { Ajax } from '../utils/ajax';
import { Like } from '../modules/like';


class AjaxMore {
    constructor(options) {
        this.opt = $.extend(true, {}, {
            listSelector: options.selector+'__block',
            itemSelector: options.selector+'__item',
            alertSelector: options.selector+'__alert',
            buttonSelector: options.selector+'__button',
            navbarSelector: options.selector+'__navbar'
        }, options);
        let self = this;
        $(this.opt.selector).each(function() {
            self.init(this);
        });
    }
    init(el) {
        console.log('[ AjaxMore/init ]');
        let th = this;
        let self = {
            is_send: false,
            $block: $(el),
            $navbar: $(el).find(this.opt.navbarSelector).hide(),
            $list: $(el).find(this.opt.listSelector),
            $item: $(el).find(this.opt.itemSelector),
            $alert: $(el).find(this.opt.alertSelector),
            $button: $(el).find(this.opt.buttonSelector)
        };
        let total = self.$button.data('total');
        if (!total) self.$alert.removeClass('m--hidden');
        if (!self.$item.length || self.$item.length >= +total) self.$button.hide();
        if (self.$button.data('action') === 'click') {
            self.$button.on('click', function(e) {
                e.preventDefault();
                th.getNextMore(self);
            });
        } else {
            self.$button.hide();

            if (self.$list.length) {
                $(window).on('scroll', () => {
                    th.scroll(self);
                });
                $(window).on('resize', () => {
                    self.$list = self.$block.find(this.opt.listSelector);
                    th.resize(self);
                });
                th.resize(self);
            }
        }
        if (+self.$button.data('page') !== 1) th.getNextMore(self, true);
    }
    scroll(self) {
        let th = this;
        let scrollTop = $(window).scrollTop();
        if (this.bodyHeight - scrollTop - this.windowHeight < self.listOffsetBottom) {
            th.getNextMore(self);
        }
    }
    resize(self) {
        let th = this;
        this.windowHeight = $(window).height();
        this.bodyHeight = $('body').outerHeight();
        self.listOffsetBottom = this.bodyHeight - self.$list.offset().top - self.$list.outerHeight();
        th.scroll(self);
    }
    getNextMore(self, replace = false) {
        let th = this;
        if (!self.is_send) {
            let params = Object.assign({}, self.$button.data());
            let method = params.method;
            let total = params.total;
            params.page = replace ? 1 : params.page + 1; 
            delete params.action;
            delete params.method;
            delete params.total;
            if (self.$item.length >= +total) return;
            if (!method) return;

            self.is_send = true;
			self.$button.addClass('is-busy');
            Ajax.get(method, params).then((data) => {
                console.log('[ AjaxMore/get/then ]');
                if (data.ok) {
                    //self.$item.last().after(data.content);
                    let $list = self.$block.find(this.opt.listSelector);
                    (replace) ? $list.html(data.content) : $list.append(data.content);
                    if ($list.hasClass('m--fixed-height')) $list.addClass('m--with-scrollbar');
                    self.$item = self.$block.find(this.opt.itemSelector);
                    let bodyHeight = $('body').outerHeight();
                    self.listOffsetBottom = bodyHeight - $list.offset().top - $list.outerHeight();
                    self.$button.data('page', params.page);
                    if (self.$item.length >= +total) self.$button.hide();
                    self.is_send = false;
					self.$button.removeClass('is-busy');
                    th.setLikes('.js-like');
                }
            });
        }
    }
    setLikes(el) {
        let store = JSON.parse(localStorage.getItem('radiobox')) || {};
        let stations = store.rating || [];
        $(el).each(function() {
            let id = $(this).data('id');
            let index = stations.indexOf(id);
            (index !== -1) ? $(this).addClass('is-active') : $(this).removeClass('is-active');
        });
    }
}


export {
    AjaxMore
};
